import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=4208e599"
import script from "./PencilIcon.vue?vue&type=script&lang=js"
export * from "./PencilIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports